module.exports = __webpack_public_path__ + "img/edit.99b161fa.svg";